import { defineStore } from 'pinia'
import { AppStoreEnum } from '#lib/enums'

export interface GamesToastStore {
  isShowCommingSoon: boolean
  isShowPromotionPrevent: boolean
  isShowNotEnoughBalance: boolean
  isShowMaintainGame: boolean
  isShowMaintainAthenaGames: boolean
  isShowMaintainProvider: boolean
  isOpenModeGameVersion: boolean
}

export const useGameToastStore = defineStore(AppStoreEnum.GameToast, {
  state: (): GamesToastStore => ({
    isShowCommingSoon: false,
    isShowPromotionPrevent: false,
    isShowNotEnoughBalance: false,
    isShowMaintainGame: false,
    isShowMaintainAthenaGames: false,
    isShowMaintainProvider: false,
    isOpenModeGameVersion: false,
  }),
  persist: false,
  actions: {
    setShowCommingSoon(value: boolean) {
      this.isShowCommingSoon = value
    },
    setShowPromotionPrevent(value: boolean) {
      this.isShowPromotionPrevent = value
    },
    setShowNotEnoughBalance(value: boolean) {
      this.isShowNotEnoughBalance = value
    },
    setShowMaintainGame(value: boolean) {
      this.isShowMaintainGame = value
    },
    setShowMaintainAthenaGames(value: boolean) {
      this.isShowMaintainAthenaGames = value
    },
    setShowMaintainProvider(value: boolean) {
      this.isShowMaintainProvider = value
    },
    setOpenModeGameVersion(value: boolean) {
      this.isOpenModeGameVersion = value
    },
  },
})
